import { computed, defineComponent, ref } from 'vue';
import { useStore } from 'vuex';
import { useSweetAlert } from '@/composables/sweetalert';
import { ProvinceTaskAction, ProvinceTaskGetter } from '@/store/provinceTask/provinceTask.module';
import { ProvinceTask, ProvinceTaskAttachment } from '@/store/provinceTask/provinceTask.model';
import BaseModalComponent from '@/components/baseModal/BaseModal.vue';

export default defineComponent({
  name: 'ProvinceTaskImageModalComponent',
  components: {
    BaseModalComponent,
  },
  props: {
    provinceTaskId: {
      type: Number,
    },
  },
  setup: (props) => {
    const store = useStore();
    const swal = useSweetAlert();
    const provinceTask = computed<ProvinceTask | undefined>(() => store.getters[ProvinceTaskGetter.BY_ID](props.provinceTaskId));
    const images = computed<ProvinceTaskAttachment[]>(() => (provinceTask.value?.provinceTaskAttachments) ? provinceTask.value?.provinceTaskAttachments.filter(m => m.attachmentType.id === 2) : []);
    const isLoading = computed(() => store.getters[ProvinceTaskGetter.STATUS] === 'init' || store.getters[ProvinceTaskGetter.STATUS] === 'loading');
    const imageModal = ref<InstanceType<typeof BaseModalComponent>>();
    const fileDialog = ref<HTMLInputElement>();

    // show modal
    const show = () => {
      imageModal.value?.show();
    };

    // hide modal
    const hide = () => {
      imageModal.value?.hide();
    };

    // open file dialog
    const fileDialogOpen = () => {
      fileDialog.value?.click();
    };

    const fileDialogChange = () => {
      const files = fileDialog.value?.files as FileList;
      store.dispatch(ProvinceTaskAction.ADD_ATTACHMENTS, {
        id: provinceTask.value?.id,
        attachmentTypeId: 2,
        names: Array(files.length).fill('image'),
        attachments: files,
      });
    };

    const deleteImage = (id: number) => {
      swal.confirm('ลบข้อมูล!', 'คุณต้องการลบข้อมูลใช่หรือไม่?', 'ใช่ ลบเดี๋ยวนี้!', '#dc3545')
        .then((result) => {
          if (result.isConfirmed) {
            store.dispatch(ProvinceTaskAction.REMOVE_ATTACHMENTS, {
              id: provinceTask.value?.id,
              attachmentIds: [id],
            });
          }
        });
    };

    return {
      images,
      imageModal,
      fileDialog,
      isLoading,
      show,
      hide,
      fileDialogOpen,
      fileDialogChange,
      deleteImage,
    };
  }
});
